import React from "react"
import { Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { formatProductsUnits } from "@ui-seeker/utils"


export default function NumSearchesBlock({ numSearches }) {
	const isDanger = numSearches >= 1000


	return <Typography variant="subtitle2" sx={{ color: isDanger ? 'error.dark' : 'success.dark', display: 'flex', alignItems: 'center', gap: .5 }}>
		{!!isDanger && <IconSeeker icon="fire" sx={{ color: 'error.main', fontSize: "0.657rem" }}/>}
		{formatProductsUnits(numSearches)}
	</Typography>
}